// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__UiyTa","formWrapper":"style_form-wrapper__LSngP","hint":"style_hint__S3w_P","controls":"style_controls__FFGUe","backBtn":"style_back-btn__fUoa8"};